<template>
  <a-modal
    title="formTitle"
    :visible="open"
    @close="onClose"
    width="50%"
    cancelText="关闭"
    @ok="submitForm">
  </a-modal>
</template>

<script>

export default {
  name: "OperateForm",
  data () {
    return {
      formTitle: null,
      open: false,
      browseList: []
    }
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    handleUser(id) {
      this.open = true
      this.formTitle = '浏览记录'
      const param = { userId: id }
    },
    submitForm() {

    },
    onClose () {
      this.open = false
    }
  }
}
</script>
